/**
 * Tiendas que reproducen un video de demostración en lugar de la señal en vivo.
 *
 * Es configuración de NEGOCIO, no lógica de protocolo: los dos caminos de reproducción
 * necesitan la misma respuesta a "¿esta tienda va con el demo?", y cada uno la reproduce a
 * su manera. Vive acá para que agregar una tienda demo no requiera tocar los dos hooks y
 * arriesgarse a que queden desalineados.
 *
 * Pendiente: los ids están en el código porque el backend todavía no expone el campo. Va
 * junto con `playbackProtocol`, que necesita el mismo cambio.
 */
const DEMO_VIDEO_STORE_IDS = ['64959fb437d1c60011b7cff2', '6939c4814d87d20011d79de8']

export const isDemoVideoStore = (store) => DEMO_VIDEO_STORE_IDS.includes(store?.id)

/**
 * El demo es contenido FINITO y de VOD, así que se repite. Una transmisión en vivo nunca
 * lleva `loop`: reinicia los timestamps y rompe cualquier medición de progreso.
 */
export const getDemoVideoUrl = () => process.env.REACT_APP_TENCENT_VOD_DEMO_VIDEO
